import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    isReportLoaded: false,
    reportList: []
}

const reportSlice = createSlice({
    name: 'reportlists', 
    initialState,
    extraReducers: (builder) => {

        builder.addCase(actions.getReports.pending, (state) => {
            state.isReportLoaded = false;
        })
        builder.addCase(actions.getReports.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.reportList = action.payload.data;
            } else {
                state.reportList = [];
            }
            state.isReportLoaded = true;
        })
        builder.addCase(actions.getReports.rejected, (state) => {
            state.isReportLoaded = false;
        }); 
    }
});

export default reportSlice.reducer;